import { create } from "zustand";

const STORAGE_KEY = "premsure-sidebar-collapsed";

const readInitial = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    /* no-op */
  }
  return false;
};

const persist = (collapsed: boolean) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch {
    /* no-op */
  }
};

interface SidebarState {
  collapsed: boolean;
  toggleSidebar: () => void;
}

export const useSidebar = create<SidebarState>((set) => ({
  collapsed: readInitial(),
  toggleSidebar: () =>
    set((prev) => {
      const next = !prev.collapsed;
      persist(next);
      return { collapsed: next };
    }),
}));
